import { __assign } from "tslib";
import * as Tone from "tone";
import { default_options as sequencer_default_options } from "./sequencer";
import { get_notes } from "./notes";
import { log } from "./firebase";
export var default_options = __assign(__assign({}, sequencer_default_options), { bpm: 60, talaVolume: 0, tanpuraVolume: -4, useSampler: false });
var Talometer = /** @class */ (function () {
    function Talometer(options) {
        if (options === void 0) { options = default_options; }
        this.options = default_options;
        this.isPlaying = false;
        this.nadai_index = -1;
        this.nextNote = function () { };
        this.tampura = new Tone.Sampler({
            urls: {
                "G4": "./sounds/tanpura-g4.mp3",
                "D3": "./sounds/tanpura-d3.mp3",
                "A#4": "./sounds/tanpura-a#4.mp3",
            },
            release: 1
        }).toDestination();
        this.update([], [], function () { }, options);
    }
    Talometer.prototype.update = function (sequence, play, nextNote, options) {
        var _this = this;
        if (sequence === void 0) { sequence = []; }
        if (play === void 0) { play = []; }
        if (nextNote === void 0) { nextNote = function () { }; }
        if (options === void 0) { options = default_options; }
        this.options = __assign({}, options);
        this.nextNote = nextNote;
        if (options.useSampler) {
            this.synth = new Tone.Sampler({
                urls: {
                    "G#4": "./sounds/up.mp3",
                    "D#3": "./sounds/down.mp3"
                },
                release: 1,
            }).toDestination();
        }
        else {
            this.synth = new Tone.Synth().toDestination();
        }
        var notes_array = get_notes(sequence, play, this.options);
        var nadai_sequence = notes_array.map(function (letter) { return Array(options.nadai).fill(letter); });
        // https://github.com/Tonejs/Tone.js/issues/580
        if (this.seq) {
            this.seq.dispose();
        }
        if (this.tampuraLoop) {
            this.tampuraLoop.dispose();
        }
        this.seq = new Tone.Sequence(function (time, note) {
            _this.nadai_index++;
            if (_this.nadai_index % _this.options.nadai === 0) {
                _this.nextNote();
            }
            if (note !== "K")
                _this.synth.triggerAttackRelease(note, 0.1, time);
        }, nadai_sequence);
        this.tampuraLoop = new Tone.Loop(function (time) {
            _this.tampura.triggerAttackRelease(options.pitch + "3", "12s", time);
        }, "1n");
        this.synth.volume.value = this.options.talaVolume || default_options.talaVolume;
        this.tampura.volume.value = this.options.tanpuraVolume || default_options.talaVolume;
    };
    Talometer.prototype.play = function () {
        var _this = this;
        log("play", { options: this.options });
        Tone.getContext().resume().then(function () {
            Tone.Transport.bpm.value = _this.options.bpm;
            _this.seq.start(0);
            _this.tampuraLoop.start(0);
            Tone.Transport.start();
            _this.isPlaying = true;
        });
    };
    Talometer.prototype.stop = function () {
        this.seq.dispose();
        this.tampuraLoop.dispose();
        this.tampura.volume.value = -999;
        Tone.Transport.stop();
        this.nadai_index = -1;
        this.isPlaying = false;
    };
    Talometer.prototype.toggle = function () {
        if (this.isPlaying) {
            this.stop();
        }
        else {
            this.play();
        }
    };
    return Talometer;
}());
export default Talometer;
